import { useStore } from "@nanostores/preact";
import type { ComponentChildren } from "preact";
import { $touchMode } from "../state/touch";

export function Panel(props: { title: string; wide?: boolean; side?: boolean; onClose?: () => void; children: ComponentChildren }) {
  const touch = useStore($touchMode);
  const cls = props.wide ? "panel wide" : props.side ? "panel side" : "panel";
  return (
    <div class={cls} role="dialog" aria-label={props.title}>
      <div class="panel-head">
        <h2>{props.title}</h2>
        {touch && props.onClose && <button class="panel-x secondary" aria-label="關閉" onClick={props.onClose}>✕</button>}
      </div>
      {props.children}
      {props.onClose && !touch && (
        <button class="secondary" onClick={props.onClose}>關閉</button>
      )}
    </div>
  );
}
